module.exports = __webpack_public_path__ + "img/LUB00032.3d16e21a.png";